export default __webpack_public_path__ + "static/media/search.61b1c747.svg";